import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import PndApi from '../../../../utils/pnd/PndRestApi';
import HubOperatorsTableView from './components/HubOperatorsTableView';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PageHeader from 'src/shared/components/layout/PageHeader';

const UserIndex = () => {
  useEffect(() => {
    getAllHubOperators();
  }, [])

  const [reactTableData, setReactTableData] = useState({ tableRowsData: [] });
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllHubOperators = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllHubOperators();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<GroupIcon fontSize="large" />}
          title="Hub Operators"
          subtitle="View and manage hub operator details and status."
          gradient="linear-gradient(135deg, #0284c7 0%, #0369a1 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData.tableRowsData && reactTableData.tableRowsData.length > 0) && !isNoRecordFound && (
            <HubOperatorsTableView reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />
          )}
          {isNoRecordFound && (
            <>
              <HubOperatorsTableView isNoRecordFound={isNoRecordFound} />
              <SnackbarContent message={'No Record Found'} sx={{ mt: 2 }} />
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default UserIndex;